
const DEFAULT_TIMEOUT = 60 * 1000;

function withTimeout(promise: any, timeout?: number): Promise<Response>{
    const effectiveTimeout = timeout || DEFAULT_TIMEOUT;
    return Promise.race([
        promise,
        new Promise((_, reject) =>
                window.setTimeout(() => reject(new Error('Timeout')), effectiveTimeout),
        ),
    ]);
}

export { withTimeout };